import i18n from '@/lang/index';
import Vue from 'vue';

// 金额处理
export function getPriceToLocale(price) {
  let priceString = price || Number(price) === 0 ? Number(price) / 100 : false;
  priceString = priceString === false ? "0.00" : priceString.toLocaleString();
  return '£'+priceString;
}
// 筛选订单状态
export function formatOrderStatus(value) {
  value = Number(value);
  switch (value) {
    case 1:
      return i18n.t('order.created')
    case 2:
      return i18n.t('order.toBeConfirmed')
    case 3:
      return i18n.t('order.PendingPayment')
    case 4:
      return i18n.t('order.pendingShipment')
    case 5:
      return i18n.t('order.partialShipment')
    case 6:
      return i18n.t('order.inTransit')
    case 7:
      return i18n.t('order.AwaitingReceipt')
    case 8:
      return i18n.t('order.completed')
    case 9:
      return i18n.t('order.ReservationInProgress')
    case 10:
      return i18n.t('order.ReservationCompleted')
    case 11:
      return i18n.t('order.closed')
    case 12:
      return i18n.t('order.Cancelled')
  }
}
// 筛选订单日志状态
export function formatOrderLog(value) {
  value = Number(value);
  switch (value) {
    case 1:
      return i18n.t('order.createdLog')
    case 2:
      return i18n.t('order.toBeConfirmedLog')
    case 3:
      return i18n.t('order.PendingPaymentLog')
    case 4:
      return i18n.t('order.pendingShipmentLog')
    case 5:
      return i18n.t('order.partialShipmentLog')
    case 6:
      return i18n.t('order.InTransitLog')
    case 7:
      return i18n.t('order.WaitToBeReceivedLog')
    case 8:
      return i18n.t('order.completedLog')
    case 9:
      return i18n.t('order.ReservationInProgressLog')
    case 10:
      return i18n.t('order.ReservationCompletedLog')
    case 11:
      return i18n.t('order.closedLog')
    case 12:
      return i18n.t('order.CancelledLog')
  }
}
// 退款状态
export const refundList = [
  {
    get label() { return i18n.t('order.RefundSuccessful') },
    status: 31
  },
  {
    get label() { return i18n.t('order.RefundSuspension') },
    status: 32
  },
  {
    get label() { return i18n.t('order.InRefund') },
    status: 33
  },
  {
    get label() { return i18n.t('order.RefundFailure') },
    status: 34
  },
]
// 退款状态对应日志
export const refundLogText = [
  {
    get label() { return i18n.t('order.RefundCompletedLog') },
    status: 31
  },
  {
    get label() { return i18n.t('order.RefundSuspensionLog') },
    status: 32
  },
  {
    get label() { return i18n.t('order.InRefundLog') },
    status: 33
  },
  {
    get label() { return i18n.t('order.RefundFailureLog') },
    status: 34
  },
]
// 退货状态列表
export const returnStatusList = [
  {
    get label() { return i18n.t('order.created') },
    status: 1
  },
  {
    get label() { return i18n.t('order.toBeConfirmed') },
    status: 2
  },
  {
    get label() { return i18n.t('order.pendingShipment') },
    status: 3
  },
  {
    get label() { return i18n.t('order.inTransit') },
    status: 4
  },
  {
    get label() { return i18n.t('order.AwaitingReceipt') },
    status: 5
  },
  {
    get label() { return i18n.t('order.completed') },
    status: 6
  },
  {
    get label() { return i18n.t('product.reviewRejected') },
    status: 7
  },
  {
    get label() { return i18n.t('order.Cancelled') },
    status: 8
  },
  {
    get label() { return i18n.t('order.PlatformIntervention') },
    status: 9
  },
  {
    get label() { return i18n.t('order.GeneratingLabel') },
    status: 10
  },
]

export const returnStatusLabelKeys = {
  1: 'order.created',
  2: 'order.toBeConfirmed',
  3: 'order.pendingShipment',
  4: 'order.inTransit',
  5: 'order.AwaitingReceipt',
  6: 'order.completed',
  7: 'product.reviewRejected',
  8: 'order.Cancelled',
  9: 'order.PlatformIntervention',
  10: 'order.GeneratingLabel'
}

// 退货状态日志列表
export const returnStatusLogList = [
  {
    get label() { return i18n.t('order.createdReturn') },
    status: 1
  },
  {
    get label() { return i18n.t('order.toBeConfirmedReturn') },
    status: 2
  },
  {
    get label() { return i18n.t('order.pendingShipmentReturn') },
    status: 3
  },
  {
    get label() { return i18n.t('order.inTransitReturn') },
    status: 4
  },
  {
    get label() { return i18n.t('order.AwaitingReceiptReturn') },
    status: 5
  },
  {
    get label() { return i18n.t('order.completedReturn') },
    status: 6
  },
  {
    get label() { return i18n.t('order.reviewRejectedReturn') },
    status: 7
  },
  {
    get label() { return i18n.t('order.CancelledReturn') },
    status: 8
  },
  {
    get label() { return i18n.t('order.PlatformProcessing') },
    status: 9
  },
  {
    get label() { return i18n.t('order.returnShippingLabelGenerating') },
    status: 10
  },
]
// 支付类型
export function formatPayTypeJS(value) {
  if (value === 1) {
    return i18n.t('order.alipay');
  } else if (value === 2) {
    return i18n.t('order.wechat');
  } else if (value === 3) {
    return i18n.t('wallet.bankCard');
  } else if (value === 4) {
    return i18n.t('order.Balance');
  } else if (value === 5) {
    return 'PayPal';
  } else if (value === 6) {
    return 'ApplePay';
  } else if (value === 7) {
    return 'GooglePay';
  } else {
    return '-';
  }
}

export function getSimpleProductAttr(arr) {
  let str = ''
  let array = JSON.parse(arr);
  if (Array.isArray(array) && array.length > 0) {
    array.forEach(item => {
      if (Object.values(item)[0]) {
        str += Object.values(item)[0] + ' / ';
      }
    })
    str = str.slice(0, -2);
    return str || "-";
  }
}

export function getProductImage(goods) {
  let spec = JSON.parse(goods.simpleProductAttr)
  return Array.isArray(spec)&&spec.length>0&&spec[0].url?
    Vue.prototype.$fileDomain +spec[0].url : ''
}

export function getOrderShipTime(endTime,nowTime) {
  const diffMs = endTime - nowTime;
  // 如果结束时间早于开始时间，返回 "已过期"（可根据需求调整）
  if (diffMs < 0) {
    return 0 + i18n.t('order.hours') + 0 + i18n.t('order.minutes');
  }

  // 将毫秒转换为分钟
  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const remainingMinutes = totalMinutes % (60 * 24);
  const hours = Math.floor(remainingMinutes / 60);
  const minutes = remainingMinutes % 60;

  // 返回格式化字符串（即使某部分为0也保留，如 "0天2小时30分钟"）
  return `${days>0?days+i18n.t('order.days'):''} ${hours} ${i18n.t('order.hours')} ${minutes} ${i18n.t('order.minutes')}`;
}



// WEBPACK FOOTER //
// ./src/views/oms/order/common.js